import React, { useEffect, useState } from "react";
import "./LoginPage.css";
// import TranslateTitleLogo from "../../assets/img/engage translate_logo_slate.png";
// import TranscriptTitleLogo from "../../assets/img/engage transcribe_logo_slate.png";
import EngageGPTLogo from "../../assets/img/engage gpt_logo_slate.png";
import { useNavigate } from "react-router";
import { Spin } from "antd";
import { Auth, Hub } from "aws-amplify";
import { EngageGPTAuthProvider } from "../../constant/constant";
import LoginImg from "../../assets/img/gpt-login-img.png";

interface LoginPageProps {}

function LoginPage(props: LoginPageProps) {
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    localStorage.clear();
  }, []);
  useEffect(() => {
    Hub.listen("auth", (data) => {
      switch (data.payload.event) {
        case "signIn":
          localStorage.setItem("cognitoUser", "true");
          localStorage.setItem("isAuthenticated", "true");
          // Auth.currentSession().then((res) => {
          //   localStorage.setItem("userData", JSON.stringify(res.getIdToken().payload));
          //   setLoading(false);

          //   navigate("/auth/documents");
          // });
          // setLoading(false);

          break;
        case "signIn_failure":
          // setLoading(false);
          setLoading(false);

          break;
        default:
          // setLoading(false);

          break;
      }
    });
  });

  const federatedLogin = async () => {
    setLoading(true);
    // localStorage.setItem("idpLogin", true);

    await Auth.federatedSignIn({ provider: EngageGPTAuthProvider });
  };
  return (
    <div className="body-container">
      <div className="logon-container">
        <div className="logon-inner-container">
          <Spin spinning={loading}>
            <div
              className="logon-item-container"
              onClick={() => federatedLogin()}>
              <img
                src={LoginImg}
                alt=""
                className="img-logo"
              />
              <img
                src={EngageGPTLogo}
                className="logo-title"
                alt=""
              />
            </div>
          </Spin>
        </div>
      </div>
    </div>
  );
}

export default LoginPage;
